import {Grid, UnstableCard as Paper} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'

import {BusinessBanner} from '../BusinessBanner/index@desktop'
import {type SectionProps as Props} from '../types'
import * as classes from './Verticals@desktop.classes'

export function VerticalsDesktop(props: Props): ReactElement {
  return (
    <Grid xs={12} item>
      <Paper className={classes.croppedPaper} padding="M" radius="L">
        <BusinessBanner {...props} />
      </Paper>
    </Grid>
  )
}
